import { jsx as t, jsxs as c } from "react/jsx-runtime";
import { memo as w, useMemo as f } from "react";
import { u as m } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { strToColor as x } from "../../../../configuration/types.js";
import { ColoredElement as y } from "@biron-data/react-components";
import { Row as n, Col as e, Select as h, Input as a } from "antd";
import { useLanguageResolver as b } from "@biron-data/react-contexts";
const M = w(({
  value: r,
  onChange: i
}) => {
  const s = b(), d = f(() => Array.from(x.entries()), []), p = f(() => d.map(([o, g]) => ({
    label: /* @__PURE__ */ t(y, { $color: g }),
    value: o
  })), [d]);
  return /* @__PURE__ */ t(u, { id: "56", gutter: [10, 10], children: /* @__PURE__ */ c(I, { gutter: [10, 10], children: [
    /* @__PURE__ */ c(n, { children: [
      /* @__PURE__ */ t(e, { span: 8, children: /* @__PURE__ */ t(l, { children: s.get("configuration-metric-options.display.interval.over") }) }),
      /* @__PURE__ */ t(e, { span: 6, children: /* @__PURE__ */ t(h, { value: r == null ? void 0 : r.firstColor, options: p, onChange: (o) => {
        r && (i == null || i({
          ...r,
          firstColor: o
        }));
      } }) })
    ] }),
    /* @__PURE__ */ c(n, { children: [
      /* @__PURE__ */ t(e, { span: 8, children: /* @__PURE__ */ t(l, { children: s.get("configuration-metric-options.display.interval.threshold") }) }),
      /* @__PURE__ */ t(e, { span: 8, children: /* @__PURE__ */ t(a, { value: r == null ? void 0 : r.step, type: "number", onChange: (o) => {
        r && (i == null || i({
          ...r,
          step: Number(o.target.value)
        }));
      } }) })
    ] }),
    /* @__PURE__ */ c(n, { children: [
      /* @__PURE__ */ t(e, { span: 8, children: /* @__PURE__ */ t(l, { children: s.get("configuration-metric-options.display.interval.below") }) }),
      /* @__PURE__ */ t(e, { span: 6, children: /* @__PURE__ */ t(h, { value: r == null ? void 0 : r.secondColor, options: p, onChange: (o) => {
        r && (i == null || i({
          ...r,
          secondColor: o
        }));
      } }) })
    ] })
  ] }) });
}), u = m(n)`
    align-items: center;
    width: 100%;
    flex-direction: column;
`, l = m.div`
    align-content: center;
    align-items: center;
    height: 100%;
`, I = m(n)`
    width: 100%;
    flex-direction: column;
`;
export {
  M as default
};
//# sourceMappingURL=IntervalSelector.js.map
